<template>
  <div class="page-points-order-details container">
    <div class="container-flex">
      <div class="green-bg">
        <div class="order-status">{{ orderData.orderStatusDesc }}</div>
        <div>
          <img class="order-icon" src="../../assets/image/mall-bg-icon.png" />
        </div>
      </div>
      <div class="order-details-info">
        <div class="">
          <div class="order-address">
            <pi-order-address
              :isRightIcon="false"
              :address="orderData.expressAddress"
              v-if="orderData.deliveryMethod == 1"
            ></pi-order-address>
            <pi-order-address
              :isRightIcon="false"
              :address="orderData.mallAddress"
              :type="2"
              v-else-if="orderData.deliveryMethod == 2"
            ></pi-order-address>
          </div>
          <div
            class="goods-code"
            v-if="orderData.deliveryMethod == 2 && orderData.pickUpCode"
          >
            <span class="code-text">取货码</span>
            <span class="code">{{ orderData.pickUpCode }}</span>
          </div>
          <div
            class="order-info"
            v-if="orderData.deliveryMethod == 1 && orderData.orderStatus == 20"
          >
            <div class="order-info-item">
              <div class="info-item-name">快递公司：</div>
              <div class="info-item-value">
                {{ orderData.expressCompanyName }}
              </div>
            </div>
            <div class="order-info-item">
              <div class="info-item-name">运单号：</div>
              <div class="info-item-value" @click="copyClick">
                {{ orderData.expressOrderNo }} <span>复制</span>
              </div>
            </div>
          </div>
          <div
            class="goods-info"
            v-if="orderData.goodsList && orderData.goodsList.length > 0"
          >
            <pi-order-item-data
              type="orderList"
              :goodsData="orderData.goodsList[0]"
            ></pi-order-item-data>
          </div>
          <div class="order-info">
            <div class="order-info-item">
              <div class="info-item-name">订单编号：</div>
              <div class="info-item-value">{{ orderData.orderNo }}</div>
            </div>
            <div class="order-info-item">
              <div class="info-item-name" v-if="orderData.exchangeTime">
                兑换时间：
              </div>
              <div class="info-item-value">{{ orderData.exchangeTime }}</div>
            </div>
            <div class="order-info-item" v-if="orderData.deliveryTime">
              <div class="info-item-name">发货时间：</div>
              <div class="info-item-value">{{ orderData.deliveryTime }}</div>
            </div>
            <div class="order-info-item" v-if="orderData.completeTime">
              <div class="info-item-name">完成时间：</div>
              <div class="info-item-value">{{ orderData.completeTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sub-btn" v-if="orderData.orderStatus == 20 && orderData.deliveryMethod ==1">
      <pi-button type="primary" block @click="receiptClick">确认收货</pi-button>
    </div>
  </div>
</template>

<script>
import { getMallorderDetail, receiveMallorder } from "../../common/api/index";
import piOrderItemData from "@/components/pi-order-item-data/pi-order-item-data";
import piOrderAddress from "@/components/pi-order-address/pi-order-address";
export default {
  name: "points-order-details",
  components: {
    [piOrderItemData.name]: piOrderItemData,
    [piOrderAddress.name]: piOrderAddress,
  },
  data() {
    return {
      orderData: {},
      orderNo: "",
    };
  },
  methods: {
    async getMallorderDetail() {
      let ret = await getMallorderDetail({
        orderNo: this.orderNo,
      });
      if (ret.status === 0) {
        this.orderData = ret.data[0] || {};
      }
    },
    receiptClick() {
      var that = this;
      this.$dialog
        .confirm({
          message: "确定收货吗",
        })
        .then(() => {
          that.receiptSub();
        })
        .catch(() => {
          // on cancel
        });
    },
    async receiptSub() {
      let orderData = this.orderData;
      let data = {
        orderNo: orderData.orderNo,
      };
      if (orderData.deliveryMethod == 2) {
        data.pickUpCode = orderData.pickUpCode;
      }
      let ret = await receiveMallorder(data);
      if (ret.status === 0) {
        this.$toast("收货成功");
        this.getMallorderDetail();
      }
    },
    copyClick() {
      this.$common.copyText(this.orderData.expressOrderNo);
    },
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo;
    this.getMallorderDetail();
  },
};
</script>

<style lang="less">
@import "../../assets/less/old/var.less";
.page-points-order-details {
  background-color: #F5F4F9;
  .green-bg{
      height: 189rpx;
      background-color: #14CC80;
      display: flex;
  }
  .order-status {
    padding: 0.4rem 0.4rem 0.9rem 0.4rem;
    font-size: 0.38rem;
    line-height: 0.53rem;
    color: #fff;
    flex: 1;
  }
  .order-icon {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.79rem;
  }

  .order-details-info {
    margin: -0.75rem 0.2rem 0 0.2rem;
  }

  .goods-code {
    padding: 0.3rem;
    text-align: center;
  }
  .goods-code,
  .order-info,
  .goods-info,
  .order-address {
    background-color: #fff;
    margin-top: 0.1rem;
    border-radius: 0.12rem;
  }
  .order-info {
    padding: 0.3rem 0.2rem;
  }
  .order-address {
    margin-top: 0rem;
    overflow: hidden;
  }
  .goods-code .code-text {
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #666;
    margin-right: 0.1rem;
  }
  .goods-code .goods-code {
    font-size: 0.58rem;
    line-height: 0.67rem;
    color: #000;
  }
  .order-info-item {
    display: flex;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #666;
    margin-top: 0.1rem;
  }
  .order-info-item:first-child {
    margin-top: 0rem;
  }
  .order-info-item .info-item-value {
    flex: 1;
    text-align: right;
  }
  .sub-btn {
    background-color: #fff;
    padding: 0.2rem;
  }
}
</style>
